import { Button } from '@mui/material';
import React from 'react';
import './style/CardButton.scss'

const CardButton = (props) => {
    return (
        <>
            <Button
                {...props}
                fullWidth={true}
                className='card-button'
            >{props.children}</Button>

        </>
    )
}

export default CardButton
